/*
 * @Desc: 
 * @Author: lmy
 * @Date: 2025-07-11 10:05:16
 * @LastEditors: lmy
 * @LastEditTime: 2025-07-25 15:57:16
 * @FilePath: \henan-h5\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        paramsStr: ''
    },
    mutations: {
        ADD_HAYAN_PARAMS: (state, view) => {
            console.log(view)
            state.paramsStr = view
        },
    },
    actions: {
        setHyQuery({ commit }, view) {
            commit('ADD_HAYAN_PARAMS', view)
        },
    },
    getters: {
        count: state => state.count
    }
})
